// @flow

import * as React from 'react';

type Props = {
  width: string,
  height: string,
  className?: string,
};

export default class ArrowRight extends React.Component<Props> {
  static defaultProps = {
    width: '100%',
    height: '100%',
  };

  render() {
    return (
      <svg
        viewBox="0 -1 6 12"
        className={this.props.className}
        width={this.props.height}
        height={this.props.width}
        style={{ fill: 'currentColor' }}
      >
        <path d="M0.550377003,10.9999578 C0.416636342,10.9999578 0.282345308,10.9515249 0.176673674,10.8530082 C-0.0462274282,10.6466182 -0.0599867555,10.2987825 0.146403154,10.075331 L4.38812857,5.49347499 L0.146953527,0.924827957 C-0.0594363824,0.702477228 -0.0467778013,0.354091061 0.176123301,0.147150779 C0.39847403,-0.0597895037 0.745759451,-0.0471309226 0.953800479,0.176320553 L5.54171057,5.11867092 C5.73764339,5.32946381 5.73764339,5.65583505 5.54226094,5.86662795 L0.954350853,10.8238384 C0.845927353,10.9410679 0.698427365,10.9999578 0.550377003,10.9999578" />
      </svg>
    );
  }
}
